import conf from '@/conf'

let rolesEncode = {
  'SuperAdmin': 1,
  'Admin': 2,
  'Manager': 3,
  'Comercial': 4
}

const GROUPS = {
  MASMOVIL: 'MasMovil',
  YOIGO: 'Yoigo',
  AVATEL: 'Avatel',
  VODAFONE: 'Vodafone',
  PUNCH_IN: 'PunchIn',
  STORAGE: 'Storage',
  LOWI: 'Lowi',
}

const ERP_GROUPS = [
  GROUPS.MASMOVIL,
  GROUPS.YOIGO,
  GROUPS.AVATEL,
  GROUPS.VODAFONE,
  GROUPS.LOWI,
]

function swapDict(dict) {
  var ret = {}
  for (var key in dict) {
    ret[dict[key]] = key
  }
  return ret
}

// Estado inicial
const state = () => ({
  host: conf.host,
  NumNotifications: 0,
  IsOpenSideBar: true,
  rolesEncode: rolesEncode,
  rolesDecode: swapDict(rolesEncode),
  GROUPS: GROUPS,
  ERP_GROUPS: ERP_GROUPS,

  utilsPath: '/api/utils/',
})

// Acciones
const actions = {
  addNotification({ commit, state }) {
    commit('NumNotifications', ++state.NumNotifications)
  },
  closeSideBar({ commit }) {
    commit('IsOpenSideBar', false)
  },
  openSideBar({ commit }) {
    commit('IsOpenSideBar', true)
  },
}

const getters = {
  getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
    rootState.general.host + endpoint
  )
}

// Mutations
const mutations = {
  NumNotifications(state, val) {
    state.NumNotifications = val
  },
  IsOpenSideBar(state, val) {
    state.IsOpenSideBar = val
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  GROUPS,
  ERP_GROUPS,
}
